/* eslint react/prop-types:"off" */
import React from 'react';
import get from 'lodash/get';
import { DidSessionProvider as ConnectSessionProvider } from '@arcblock/did-connect/lib';
import { SessionProvider as PlaygroundSessionProvider } from '@arcblock/did-playground/lib/Action/session';
import withTheme from '@arcblock/ux/lib/withTheme';
import withI18n from './withI18n';
import { translations } from '../libs/locale';
var appDid = process.env.GATSBY_DID_CONNECT_APP_DID;
var connectServiceHost = process.env.GATSBY_DID_CONNECT_SERVICE;
var authAction = process.env.GATSBY_DID_CONNECT_AUTH_ACTION || '';
var authAPIPrefix = process.env.GATSBY_DID_CONNECT_API_PREFIX || '';
var playgroundServiceHost = process.env.GATSBY_PLAYGROUND_SERVICE;
var serviceHosts = {
  en: connectServiceHost,
  zh: process.env.GATSBY_DID_CONNECT_SERVICE_ZH || connectServiceHost
};
export default (function (themeConfig) {
  if (themeConfig === void 0) {
    themeConfig = {};
  }

  return function (ComposedComponent) {
    function WithRoot(props) {
      // We have did-connect enabled
      if (appDid && connectServiceHost) {
        var locale = get(props, 'pageContext.locale', 'en'); // We have both did-connect and playground enabled

        if (playgroundServiceHost) {
          return /*#__PURE__*/React.createElement(ConnectSessionProvider, {
            appDid: appDid,
            serviceHost: serviceHosts[locale],
            authAction: authAction,
            authAPIPrefix: authAPIPrefix,
            locale: locale
          }, /*#__PURE__*/React.createElement(PlaygroundSessionProvider, {
            serviceHost: playgroundServiceHost,
            autoLogin: false
          }, /*#__PURE__*/React.createElement(ComposedComponent, props)));
        } // Only have did-connect enabled


        return /*#__PURE__*/React.createElement(ConnectSessionProvider, {
          appDid: appDid,
          serviceHost: serviceHosts[locale],
          authAction: authAction,
          authAPIPrefix: authAPIPrefix,
          locale: locale
        }, /*#__PURE__*/React.createElement(ComposedComponent, props));
      } // Only have playground enabled


      if (playgroundServiceHost) {
        return /*#__PURE__*/React.createElement(PlaygroundSessionProvider, {
          serviceHost: playgroundServiceHost,
          autoLogin: false
        }, /*#__PURE__*/React.createElement(ComposedComponent, props));
      } // Just the page


      return /*#__PURE__*/React.createElement(ComposedComponent, props);
    }

    return withTheme(withI18n(translations)(WithRoot), themeConfig);
  };
});